import React, { useContext } from 'react';
import { InboundContext } from '../../../../context/InboundContext';
import { FormGroup } from '../../../common';
import { Heading } from '../../../styledComponents';
import styles from '../FormContainer.module.css';

type PersonalInformationType = {
  firstName: string;
  lastName: string;
  email: string;
};

type PersonalInformationProps = {
  personalInformation: PersonalInformationType;
  setPersonalInformation: React.Dispatch<React.SetStateAction<PersonalInformationType>>;
};

export default function PersonalInformation({ personalInformation, setPersonalInformation }: PersonalInformationProps) {
  const { inboundData, t } = useContext(InboundContext);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPersonalInformation({ ...personalInformation, [name]: value });
  };

  return (
    <div>
      {(inboundData?.formSetupPage?.firstName ||
        inboundData?.formSetupPage?.lastName ||
        inboundData?.formSetupPage?.email) && (
        <div className={styles.formSection}>
          <Heading as="h3" fontWeight="500" fontSize="16px" color="#353535" textTransform="uppercase">
            {t('personalInfoHeader')}
          </Heading>
          <div className={styles.group}>
            {inboundData?.formSetupPage?.firstName && (
              <FormGroup
                id="firstName"
                name="firstName"
                label={t('firstNameLabel')}
                type="text"
                placeholder="Jen"
                value={personalInformation.firstName}
                onChange={handleInputChange}
                errorText=""
                required
              />
            )}
            {inboundData?.formSetupPage?.lastName && (
              <FormGroup
                id="lastName"
                name="lastName"
                label={t('lastNameLabel')}
                type="text"
                placeholder="Nelson"
                value={personalInformation.lastName}
                onChange={handleInputChange}
                errorText=""
                required
              />
            )}
          </div>
          {inboundData?.formSetupPage.email && (
            <FormGroup
              id="email"
              name="email"
              label={t('emailAddressLabel')}
              type="email"
              placeholder="jennelson@gmail.com"
              value={personalInformation.email}
              onChange={handleInputChange}
              errorText=""
              required
              disabled
            />
          )}
        </div>
      )}
    </div>
  );
}
